module.exports = __webpack_public_path__ + "res/Roboto-Regular-webfont.ttf?e7e5c918f2932bac05144e83755cde20";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Regular-webfont.ttf
// module id = 14
// module chunks = 0